import { Icon, IconName } from 'src/components/Icon';
import styles from './ModelPricingMobileTable.module.scss';
import { TextDivider } from 'src/v2/commonComponents/TextDivider';
import { ModelPricingMobileRow } from '../ModelPricingMobileRow';
import { MODEL_PRICING_DATA_NEW } from 'src/constants';
import { ModelPricingModel } from 'src/types';

export const ModelPricingMobileTable = () => {
  return (
    <div className={styles.root}>
      {MODEL_PRICING_DATA_NEW.map(
        ({ companyName, companyLogo, models }, rowIndex) => {
          return (
            <div key={rowIndex} className={styles.pricingSection}>
              <div className={styles.companyName}>
                <Icon type={companyLogo as IconName} />
                {companyName}
              </div>

              <div className={styles.list}>
                {models.map((modelItem: ModelPricingModel) => (
                  <ModelPricingMobileRow
                    key={modelItem.modelName}
                    modelName={modelItem.modelName}
                    inputPrice={modelItem.inputPrice}
                    outputPrice={modelItem.outputPrice}
                    // price={modelItem.price}
                    currency={modelItem.currency}
                    modelDescription={modelItem.modelDescription}
                    defaultModels={modelItem.defaultModels}
                  />
                ))}
              </div>

              {rowIndex !== MODEL_PRICING_DATA_NEW.length - 1 && (
                <TextDivider />
              )}
            </div>
          );
        },
      )}
    </div>
  );
};
